import { render, staticRenderFns } from "./RequestType.vue?vue&type=template&id=2658db66&"
import script from "./RequestType.vue?vue&type=script&lang=js&"
export * from "./RequestType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports